const AIProcessing = ({ size=24, color="#12a87a", ...props }) => (
    <svg
        width={size}
        height={size}
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props} // Allows you to override width, height, etc.
    >
        <path
            d="M12 2L15 8H9L12 2ZM6 9H18V22H6V9Z"
            fill={color}
        />
    </svg>
);

export default AIProcessing;
